module.exports = __webpack_public_path__ + "static/media/redPacket3x.533a1005.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/redPacket3x.png
// module id = 555
// module chunks = 6